import type { ICompany } from '@/types/company.type';

import { proAccountApiUrl } from '@/constants';
import axiosWrapper from '@mylight150/axios-wrapper';

export const getUserCompanies = async (forceRefresh?: boolean): Promise<ICompany[]> => {
  if (!forceRefresh) {
    const userCompaniesStorage = sessionStorage.getItem('userCompanies');

    if (userCompaniesStorage) {
      const userCompaniesStorageParsed: ICompany[] = JSON.parse(userCompaniesStorage);

      if (userCompaniesStorageParsed.length) {
        return userCompaniesStorageParsed;
      }
    }
  }

  const response = await axiosWrapper.get(`${proAccountApiUrl}/companies`);
  return response.data as ICompany[];
};
